var React = require('react');

function Profile (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M 12,0.26136 A 5.9905662,5.8693201 0 1 1 12,12 5.9905662,5.8693201 0 0 1 12,0.26136 Z m 0,14.673301 c 6.61872,0 11.981132,2.6261 11.981132,5.86932 V 23.73864 H 0.01886797 v -2.934659 c 0,-3.24322 5.36241243,-5.86932 11.98113203,-5.86932 z","style":{"strokeWidth":"1.69419"}}));
}

Profile.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = Profile;

Profile.default = Profile;
